import { RequestedGender } from './types';

// Also keyed in bookings-checkout-viewer and bookings-catalog; keep identical.

export const GENDER_FILTER_OPTION_KEYS: Record<RequestedGender, string> = {
  [RequestedGender.ANY_FEMALE]: 'filter.staff-gender.any-female',
  [RequestedGender.ANY_MALE]: 'filter.staff-gender.any-male',
};

/**
 * The `summary.` variants of these are lower case on purpose — the preferences
 * modal renders them after a "With" prefix. The calendar summary has no prefix
 * and sits them beside real staff names, so it takes the standalone labels.
 */
export const ANY_GENDER_STAFF_SUMMARY_KEYS: Record<RequestedGender, string> = {
  [RequestedGender.ANY_FEMALE]:
    'services-preferences-modal.select-any-female-staff',
  [RequestedGender.ANY_MALE]:
    'services-preferences-modal.select-any-male-staff',
};
